import type { IconSvgObject } from './types';

const TextFirstlineRightIcon: IconSvgObject = [
  ["path", { d: "M15 3.5H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15 9.5H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M3 15.5H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M3 21.5H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M9 2.5H5C3.89543 2.5 3 3.39543 3 4.5V8.5C3 9.60457 3.89543 10.5 5 10.5H9C10.1046 10.5 11 9.60457 11 8.5V4.5C11 3.39543 10.1046 2.5 9 2.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default TextFirstlineRightIcon;
